import * as actions from './contactView.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { ContactViewModel } from '@smarttask-common/src/lib/models/CRM/View/ContactViewModel';

export const viewAdapter = createEntityAdapter<ContactViewModel>({
    selectId: (x) => x.view_id,
});
export interface ContactViewState extends EntityState<ContactViewModel> {
    selected_view_id: string;
}

export const initialState: ContactViewState = viewAdapter.getInitialState({
    selected_view_id: undefined,
});

export function ContactViewReducers(state: ContactViewState = initialState, action: actions.ContactViewActions) {
    switch (action.type) {
        case actions.ContactViewActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_view_id: action.selected_view_id };
            return state;

        case actions.ContactViewActionTypes.ADD_CONTACTVIEW:
            return viewAdapter.addOne(action.view, { ...state, selected_view_id: state.selected_view_id });

        case actions.ContactViewActionTypes.ADD_CONTACTVIEWS:
            return viewAdapter.addMany(action.views, { ...state, selected_view_id: state.selected_view_id });

        case actions.ContactViewActionTypes.UPSERT_CONTACTVIEW:
            return viewAdapter.upsertOne(action.view, { ...state, selected_view_id: state.selected_view_id });

        case actions.ContactViewActionTypes.UPSERT_CONTACTVIEWS:
            return viewAdapter.upsertMany(action.views, { ...state, selected_view_id: state.selected_view_id });

        case actions.ContactViewActionTypes.UPDATE_CONTACTVIEW:
            return viewAdapter.updateOne(
                {
                    id: action.view_id,
                    changes: action.changes,
                },
                { ...state, selected_view_id: state.selected_view_id }
            );

        case actions.ContactViewActionTypes.UPDATE_CONTACTVIEWS:
            return viewAdapter.updateMany(action.updates, { ...state, selected_view_id: state.selected_view_id });

        case actions.ContactViewActionTypes.DELETE_CONTACTVIEW:
            // if(state.selected_view_id == action.id){
            //   state.selected_view_id = undefined;
            // }
            return viewAdapter.removeOne(action.id, { ...state, selected_view_id: state.selected_view_id });

        case actions.ContactViewActionTypes.DELETE_CONTACTVIEWS:
            // if(action.ids.indexOf(state.selected_view_id) > -1){
            //   state.selected_view_id = undefined;
            // }
            return viewAdapter.removeMany(action.ids, { ...state, selected_view_id: state.selected_view_id });

        case actions.ContactViewActionTypes.DELETE_STATE:
            state.selected_view_id = undefined;
            return viewAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getContactViewState = createFeatureSelector<ContactViewState>('contactView');

const getSelectedViewIdState = (state: ContactViewState) => {
    return state.selected_view_id;
};
export const getSelectedViewId = createSelector(getContactViewState, getSelectedViewIdState);

export const getSelectedView = createSelector(getContactViewState, (state: ContactViewState) => {
    if (state.selected_view_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_view_id];
});

export const { selectIds, selectEntities, selectAll, selectTotal } = viewAdapter.getSelectors(getContactViewState);
